<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="师傅id,外键{}" prop="userId" >
              <a-input v-model="form.userId" placeholder="请输入师傅id,外键{}" />
            </a-form-model-item>-->
      <a-form-model-item label="师傅名称">
        <a-input v-model="form.userName" disabled placeholder="—"/>
      </a-form-model-item>
      <a-form-model-item label="营业执照">
        <div v-if="businessLicensePreviewUrl" class="license-preview-wrap">
          <img
            v-viewer
            class="license-preview-img"
            :src="businessLicensePreviewUrl"
            preview="营业执照"
          />
        </div>
        <span v-else class="text-muted">暂无</span>
      </a-form-model-item>
      <a-form-model-item label="企业名称">
        <a-input v-model="form.enterpriseName" disabled placeholder="请输入企业名称"/>
      </a-form-model-item>
      <a-form-model-item label="所属行业">
        <a-input v-model="form.sectorName" disabled placeholder="请输入所属行业"/>
      </a-form-model-item>
      <a-form-model-item label="省市区">
        <a-input :value="regionDisplay" disabled placeholder="省市区"/>
      </a-form-model-item>
      <!--
      <a-form-model-item label="省编码" prop="provinceCode">
        <a-input v-model="form.provinceCode" placeholder="请输入省编码" />
      </a-form-model-item>
      -->
      <a-form-model-item label="详细地址">
        <a-input v-model="form.detailedAddress" disabled placeholder="请输入详细地址"/>
      </a-form-model-item>
      <a-form-model-item label="统一社会信用代码">
        <a-input v-model="form.unifiedSocialCreditCode" disabled placeholder="请输入统一社会信用代码"/>
      </a-form-model-item>
      <a-form-model-item label="法人姓名">
        <a-input v-model="form.corporationName" disabled placeholder="请输入法人姓名"/>
      </a-form-model-item>
      <a-form-model-item label="法人身份证号">
        <a-input v-model="form.corporationIdNumber" disabled placeholder="请输入法人身份证号"/>
      </a-form-model-item>
      <a-form-model-item label="主营业务">
        <a-input v-model="form.mainBusiness" disabled placeholder="请输入主营业务"/>
      </a-form-model-item>
      <a-form-model-item label="联系方式">
        <a-input v-model="form.contactInformation" disabled placeholder="请输入联系方式"/>
      </a-form-model-item>
      <a-form-model-item label="审核状态" prop="examineStatus">
        <a-select v-model="form.examineStatus">
          <a-select-option :value="0">待审核</a-select-option>
          <a-select-option :value="1">已通过</a-select-option>
          <a-select-option :value="2">已拒绝</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="审核原因" prop="examineReason" >
        <a-input v-model="form.examineReason" placeholder="请输入审核原因" allow-clear />
      </a-form-model-item>
      <!--      <a-form-model-item label="备注" prop="remark" >
              <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
            </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addCertification, getCertification, updateCertification } from '@/api/enterprise/certification'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        userName: null,
        businessLicense: null,
        enterpriseName: null,
        sector: null,
        sectorName: null,
        provinceName: null,
        provinceCode: null,
        cityName: null,
        cityCode: null,
        areaName: null,
        areaCode: null,
        detailedAddress: null,
        unifiedSocialCreditCode: null,
        corporationName: null,
        corporationIdNumber: null,
        mainBusiness: null,
        contactInformation: null,
        examineStatus: 0,
        examineReason: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        examineStatus: [
          { required: true, message: '请选择审核状态', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    regionDisplay () {
      const parts = [this.form.provinceName, this.form.cityName, this.form.areaName].filter(
        (p) => p != null && String(p).trim() !== ''
      )
      return parts.length ? parts.join(' / ') : '—'
    },
    businessLicensePreviewUrl () {
      const v = this.form.businessLicense
      return v != null && String(v).trim() !== '' ? String(v).trim() : ''
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        userName: null,
        businessLicense: null,
        enterpriseName: null,
        sector: null,
        sectorName: null,
        provinceName: null,
        provinceCode: null,
        cityName: null,
        cityCode: null,
        areaName: null,
        areaCode: null,
        detailedAddress: null,
        unifiedSocialCreditCode: null,
        corporationName: null,
        corporationIdNumber: null,
        mainBusiness: null,
        contactInformation: null,
        examineStatus: 0,
        examineReason: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCertification({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = response.data.examineStatus === 0 ? '审核' : '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCertification(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCertification(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
/* 与实体执照横向比例接近，抽屉内大图完整展示 */
.license-preview-wrap {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 85.6 / 54;
  max-height: min(42vh, 320px);
  min-height: 140px;
  box-sizing: border-box;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  line-height: 0;
}
.license-preview-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  cursor: pointer;
  display: block;
}
.text-muted {
  color: rgba(0, 0, 0, 0.25);
}
</style>
